export default __webpack_public_path__ + "static/media/vast_icon.f82d1380.svg";